import { DIAS } from '../config'

const PLACEHOLDER = /\{\{(\w+)\}\}/g

// WhatsApp no acepta saltos de línea ni tabs dentro de un parámetro: el backend los
// convierte en espacios, y la vista previa muestra lo mismo que va a llegar.
export const cleanParam = value => String(value ?? '').replace(/\s+/g, ' ').trim()

// Los campos vacíos se muestran con su nombre entre corchetes para ver dónde va cada uno.
export const renderTemplate = (template, values = {}) =>
  String(template?.body || '').replace(PLACEHOLDER, (_, key) => {
    const label = template.params?.find(param => param.key === key)?.label || key
    return cleanParam(values[key]) || `[${label}]`
  })

// departure_time viene en hora local con sufijo Z: se lee el texto tal cual, sin pasar por Date.
export const formatTrip = lobby => {
  const journey = lobby?.Journey
  if (!journey) return ''
  const origin = journey.origin_name?.locality
  const destination = journey.destination_name?.locality
  const route = origin && destination ? `de ${origin} a ${destination}` : ''
  const match = String(journey.departure_time || '').match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}:\d{2})/)
  if (!match) return route
  const [, year, month, day, time] = match
  const weekday = DIAS[new Date(Date.UTC(+year, +month - 1, +day)).getUTCDay()].toLowerCase()
  return `${route} del ${weekday} ${day}/${month} a las ${time}`.trim()
}

export const tripLink = lobby =>
  lobby?._id
    ? `https://app.viatik.com/join/${lobby._id}?utm_source=admin&utm_medium=whatsapp&utm_campaign=soporte`
    : ''

const FILLERS = {
  first_name: ({ user }) => cleanParam(user?.first_name),
  trip: ({ lobby }) => formatTrip(lobby),
  trip_link: ({ lobby }) => tripLink(lobby)
}

export const prefillValues = (template, context = {}) =>
  Object.fromEntries(
    (template?.params || []).map(param => [param.key, FILLERS[param.fill]?.(context) || ''])
  )

export const missingParams = (template, values = {}) =>
  (template?.params || []).filter(param => !cleanParam(values[param.key])).map(param => param.key)

export const whatsappLink = (phoneNumber, text = '') => {
  const phone = String(phoneNumber || '').replace(/\D/g, '')
  return `https://api.whatsapp.com/send/?phone=${phone}&text=${encodeURIComponent(text || ' ')}`
}

const WHATSAPP_ERRORS = {
  132001: 'Esta plantilla todavía no está aprobada en Meta para este número.',
  132000: 'La plantilla aprobada en Meta tiene otra cantidad de campos.',
  132005: 'El mensaje quedó demasiado largo. Acortá el texto.',
  131026: 'No se pudo entregar: el número no tiene WhatsApp o no acepta mensajes de empresas.',
  131049: 'Meta decidió no entregarlo para cuidar la experiencia del usuario. Probá más adelante.',
  131050: 'El usuario dejó de recibir mensajes de marketing de Viatik.',
  131056: 'Se mandaron demasiados mensajes seguidos a este número. Probá en unos minutos.'
}

const REQUEST_ERRORS = {
  invalid_param: 'Revisá los campos: hay uno vacío o demasiado largo.',
  invalid_request: 'La plantilla elegida ya no existe. Recargá la página.',
  invalid_sender: 'Ese número ya no está disponible. Recargá la página.',
  user_not_found: 'No encontramos al usuario.',
  invalid_phone: 'El usuario no tiene un teléfono válido para WhatsApp.',
  not_configured: 'No hay ningún número de WhatsApp configurado en el servidor.',
  whatsapp_unreachable: 'No se pudo conectar con WhatsApp. Probá de nuevo.',
  contact_error: 'No se pudo encontrar ni crear el contacto en Ventia. Probá de nuevo.'
}

export const sendErrorMessage = (body = {}) => {
  if (body.error === 'whatsapp_error') {
    return (
      WHATSAPP_ERRORS[body.code] ||
      `WhatsApp rechazó el mensaje${body.code ? ` (${body.code})` : ''}${body.detail ? `: ${body.detail}` : '.'}`
    )
  }
  return REQUEST_ERRORS[body.error] || 'No se pudo enviar el mensaje.'
}
